import React, { useState } from "react";
import Layout from "../../../HOC/layout/Layout";
import AddBooking from "../../PageComponent/BookingSection/AddBooking";
import ViewBooking from "../../PageComponent/BookingSection/ViewBooking";
import ContextApi from "../../../HOC/ContextsAPI/ContextApi";
import SecondaryHeader from "../../UI/SecondaryHeader/SecondaryHeader";

function Booking() {
  const [showData, setShowData] = useState("Add");
  const [Tbody, setTbody] = useState([]);
  const SearchText = () => {
    console.log(4);
  };
  return (
    <ContextApi>
      <Layout>
        <div>
          <SecondaryHeader
            setShowData={setShowData}
            showData={showData}
            addBtn="AddBooking"
            viewBtn="ViewBooking"
            SearchText={SearchText}
          />
          {showData === "Add" ? (
            <AddBooking
              setShowData={setShowData}
              //    getBooking={getBooking}
            />
          ) : (
            <ViewBooking
              setShowData={setShowData}
              // getBooking={getBooking}
              Tbody={Tbody}
              setTbody={setTbody}
            />
          )}
        </div>
      </Layout>
    </ContextApi>
  );
}

export default Booking;
